import Icon from '../components/Icon.vue'

Icon.register({"tv":{"width":2048,"height":1792,"paths":[{"d":"M1792 1248v-960q0-13-9.5-22.5t-22.5-9.5h-1600q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5zM1920 288v960q0 66-47 113t-113 47h-736v128h352q14 0 23 9t9 23v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-128h-736q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1600q66 0 113 47t47 113z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tv.js
// module id = 1831
// module chunks = 0